import {
  ArrayInput,
  Button,
  maxLength,
  required,
  SelectInput,
  SimpleFormIterator,
  TextInput,
  useNotify,
  useRefresh,
} from "react-admin";
import FlightLandIcon from "@mui/icons-material/FlightLand";
import { Grid } from "@mui/material";

import { settings } from "app";
import { erasmusRequests } from "api/erasmusApi";
import CustomDateInput from "server/components/Fields/CustomDateInput";
import FormModal from "server/components/Modals/FormModal";
import dataProvider from "server/dataProvider";

const COMMENTS_SOURCE = "comments";

const CoordinatorArriveDialog = ({ id, internships = [] }) => {
  const notify = useNotify();
  const refresh = useRefresh();

  // The comments are optional and free-form - a coordinator can leave none, one per internship,
  // or several for the same internship, so the rows are added by hand.
  const internshipChoices = internships.map(internship => ({ id: internship?.id, name: internship?.name }));

  const defaultValues = {
    arrivalDate: new Date().toISOString().split("T")[0],
    [COMMENTS_SOURCE]: [],
  };

  const handleArrive = async data => {
    const comments = (data[COMMENTS_SOURCE] ?? []).map(item => ({
      internshipId: item.internshipId,
      comment: item.comment.trim(),
    }));

    const payload = {
      arrivalDate: data.arrivalDate,
      comments: comments.length ? comments : null,
    };

    await dataProvider.customRequest(erasmusRequests.arriveIncomingInternshipStudent(id), payload, "PUT");
    notify("Студентът е отбелязан като пристигнал", { type: "success" });
    refresh();
  };

  return (
    <FormModal
      titleContent="Отбелязване на пристигане"
      dialogSize="md"
      defaultValues={defaultValues}
      onConfirm={handleArrive}
      triggerButton={
        <Button
          label="Пристигнал"
          variant="contained"
          color="success"
          startIcon={<FlightLandIcon />}
        />
      }
    >
      <Grid
        container
        spacing={2}
      >
        <Grid
          item
          xs={12}
          md={6}
        >
          <CustomDateInput
            source="arrivalDate"
            label="Дата на пристигане"
            noTime
            required={true}
            validate={required()}
          />
        </Grid>
        <Grid
          item
          xs={12}
        >
          <ArrayInput
            source={COMMENTS_SOURCE}
            label="Коментари по стажовете"
            fullWidth
          >
            <SimpleFormIterator
              inline={false}
              disableReordering
              sx={settings.style.iteratorWithoutGap}
            >
              <Grid
                container
                spacing={2}
              >
                <Grid
                  item
                  xs={12}
                >
                  <SelectInput
                    source="internshipId"
                    label="Стаж"
                    choices={internshipChoices}
                    optionText="name"
                    fullWidth
                    validate={[required()]}
                  />
                </Grid>
                <Grid
                  item
                  xs={12}
                >
                  <TextInput
                    source="comment"
                    label="Коментар"
                    sx={settings.style.textAria}
                    variant="outlined"
                    fullWidth
                    multiline
                    validate={[required(), maxLength(500)]}
                  />
                </Grid>
              </Grid>
            </SimpleFormIterator>
          </ArrayInput>
        </Grid>
      </Grid>
    </FormModal>
  );
};

export default CoordinatorArriveDialog;
